import { h } from 'preact'
import { TFunctionDetailedResult } from 'i18next'
import { i18n } from 'i18n/i18n'

interface CalculatorCtaButtonProps {
  href: string
  label?: TFunctionDetailedResult
  openInNewTab?: boolean
}

export const CalculatorCtaButton = ({
  href,
  label = i18n('calculator.ctaButton'),
  openInNewTab = false,
}: CalculatorCtaButtonProps) => (
  <a
    className="calculator-cta button button--fw-600"
    href={href}
    data-calculator-cta
    data-track-click="anchor-button"
    {...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
  >
    {label}
  </a>
)
